import { batch } from 'react-redux';

import { getPastFeedbacks } from 'services/performanceReview';

import { apiMetaUpdateHasMoreAction, apiMetaUpdateOffsetAction } from './apiPaginationMeta';
import { apiStatusSetCompletedAction, apiStatusSetLoadingAction, apiStatusSetLoadingMoreAction } from './apiStatus';

export const REVIEWS_REDUCER_ADD = 'REVIEWS_REDUCER_ADD';
export const REVIEWS_REDUCER_UPDATE = 'REVIEWS_REDUCER_UPDATE';

export function fetchReviewsAction({ type = null, globalFilters = {}, receiverEmployeeId }) {
  return (dispatch, getState) => {
    const state = getState();
    const limit = 5;
    const offset = 0;
    dispatch(apiStatusSetLoadingAction());
    return getPastFeedbacks({ offset, limit, includeCount: true, receiverEmployeeId })
      .then((res) => {
        const { reviews, totalCount } = res;
        batch(() => {
          dispatch(updateReviewsAction(reviews));
          dispatch(apiStatusSetCompletedAction());
          dispatch(apiMetaUpdateOffsetAction(totalCount < limit ? 0 : offset + limit));
          dispatch(apiMetaUpdateHasMoreAction(!(totalCount <= offset + limit)));
        });
      })
      .catch((err) =>
        batch(() => {
          dispatch(apiStatusSetCompletedAction());
          dispatch(apiMetaUpdateHasMoreAction(false));
        })
      );
  };
}

export function fetchMoreReviewsAction({ receiverEmployeeId }) {
  return (dispatch, getState) => {
    const state = getState();
    const { limit = 5, offset = 0 } = state.apiPaginationMeta;
    dispatch(apiStatusSetLoadingMoreAction());
    return getPastFeedbacks({ limit, offset, includeCount: true, receiverEmployeeId })
      .then((res) => {
        const { reviews, totalCount } = res;
        batch(() => {
          dispatch(addReviewsAction(reviews));
          dispatch(apiStatusSetCompletedAction());
          dispatch(apiMetaUpdateOffsetAction(totalCount < limit ? 0 : offset + limit));
          dispatch(apiMetaUpdateHasMoreAction(!(totalCount <= offset + limit)));
        });
      })
      .catch((err) =>
        batch(() => {
          dispatch(apiStatusSetCompletedAction());
          dispatch(apiMetaUpdateHasMoreAction(false));
        })
      );
  };
}

export function updateReviewsAction(reviews) {
  return { type: REVIEWS_REDUCER_UPDATE, reviews };
}

export function addReviewsAction(reviews) {
  return { type: REVIEWS_REDUCER_ADD, reviews };
}
